// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "._2Cw0UTE6HJMisPxFWk8fxt {\n  margin-top: 2rem;\n  display: flex;\n  justify-content: center;\n  \n}", "",{"version":3,"sources":["History.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;;AAEzB","file":"History.css","sourcesContent":[".Styles {\n  margin-top: 2rem;\n  display: flex;\n  justify-content: center;\n  \n}"]}]);
// Exports
exports.locals = {
	"Styles": "_2Cw0UTE6HJMisPxFWk8fxt"
};
module.exports = exports;
